import React from "react";
import { Box, Typography } from "@mui/material";
import globalStyles from "../../global";

const statsData = [
  { value: "700+", label: "Franchises "  },
  { value: "200+", label: "Cities" },
  { value: "7+", label: "Global Presence" },
  { value: "2M+", label: "Customers" },
];

const Stats = () => {
  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.contentWrapper}>
        <Box sx={styles.statsGrid}>
          {statsData.map((stat, index) => (
            <React.Fragment key={index}>
              <Box sx={styles.statItem}>
                <Box sx={styles.textContainer}>
                  <Typography sx={styles.statValue}>{stat.value}</Typography>
                  <Typography sx={styles.statLabel}>
                    {stat.label}
                  </Typography>
                </Box>
              </Box>
              {index !== statsData.length - 1 && (
                <Box sx={styles.divider} />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainContainer: {
    width: "100%",
    backgroundColor: globalStyles.colors.base_light,
    padding: { xs: "20px", md: "40px 0" },
    borderTop: `1px solid ${globalStyles.colors.army_green}`,
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: { xs: "0 16px", md: "0 24px" },
  },
  statsGrid: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "row", // Always row, even on mobile
    flexWrap: "nowrap", // Don't wrap, keep items in a single row
    width: "100%",
    gap: 0,
    overflowX: { xs: "auto", md: "unset" }, // Allow horizontal scroll on mobile if needed
  },
  statItem: {
    flex: "1 1 0%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0,
    px: { xs: 1, md: 2 },
    whiteSpace: "nowrap",
  },
  textContainer: {
    textAlign: "center",
  },
  statValue: {
    color: globalStyles.colors.army_green,
   fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
    fontWeight: 600,
    fontFamily: globalStyles.fonts.primary,
    margin: 0,
  },
  statLabel: {
    color: globalStyles.colors.text,
    fontSize: {
      xs: "10px",
      sm:"16px",
      md: "26px",
    },
    fontFamily: globalStyles.fonts.primary,
    margin: 0,
    whiteSpace: "nowrap",
    fontWeight: 400,
  },
  divider: {
    height: { xs: "48px", md: "81px" ,sm: "60px",}, // Vertical divider always
    width: "2px",
    backgroundColor: "#A5D46E",
    mx: "auto",
    my: 0,
    alignSelf: "stretch",
  },
};

export default Stats;